import React from 'react';

export const Callout: React.FC = () => {
    return (
        <div className='callout'>
            <div className='row'>
                <div
                    className='columns small-12 large-12 blue-text'
                    style={{ fontSize: '1.3em', textAlign: 'center' }}
                >
                    <b>START HERE!</b> This is all or most of what we need to size your loan.
                </div>
            </div>
        </div>
    );
};
